module.exports = __webpack_public_path__ + "img/KIDIWI-services-gradient.svg";